export default __webpack_public_path__ + "static/The_extreme_life_of_Europes_sherpas-174bba2172d4717184655c308c79bf14.jpg";